import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from '../../redux/actions/user.actions';
import DocumentsTable from './DocumentsTable';
import './DocumentsComponent.styles.scss';

const SignedDocumentsComponent = () => {
  const dispatch = useDispatch();
  const companyProfile = useSelector((state) => state.companyProfile);
  const signedDocuments = useSelector((state) => state.companySignedDocuments);
  const [isLoading, setIsLoading] = useState(false);

  const { items: companySignedDocuments = [] } = signedDocuments || {};
  const { items } = companyProfile || {};
  const { company } = items || {};
  const { ACN: companyACN } = company || {};

  useEffect(() => {
    if (companyACN) {
      dispatch(userActions.getCompanySignedDocuments(companyACN))
    }
  }, [dispatch, companyACN]);

  const handleDownload = ({ FileName }) => {
    dispatch(userActions.downloadCompanySignedDocuments(companyACN, FileName, setIsLoading))
  };

  const hasFiles = useMemo(() => companySignedDocuments.length > 0, [companySignedDocuments]);

  return (
    <div className="odc-wrap">
      {isLoading && (
        <div className="odc-loading-overlay" aria-live="polite" aria-busy="true">
          <div className="odc-spinner" />
        </div>
      )}

      <div className="odc-grid" role="list">
        {hasFiles && (
          <DocumentsTable
            data={{
              loading: false,
              items: companySignedDocuments,
              total: companySignedDocuments.length,
            }}
            isLoading={isLoading}
            onDownload={(doc) => handleDownload(doc)}
          />
        )}
      </div>
    </div>
  );
};

export default SignedDocumentsComponent;